angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(['$transitions', '$uibModalStack', function ($transitions, $uibModalStack) {

        $transitions.onSuccess({}, function dismissAllModals() {
            $uibModalStack.dismissAll('pageTransition');
        });
    }]);
}]);

